import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { TiTick } from "react-icons/ti";
import { MdOutlineLock } from "react-icons/md";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import '../../components/NewPassword/NewPassword.css';
import ResetPassword from "../../components/ResetPassword/ResetPassword";
import { resetPassword } from "../../API/Api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewPassword = ({ isOpen, onClose, email, userType, token }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [errors, setErrors] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Password strength state
    const [passwordStrength, setPasswordStrength] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
    });

    const validatePassword = () => {
        if (newPassword !== repeatPassword) {
            setErrors({ confirmPassword: "Passwords do not match." });
            return false;
        }

        if (!passwordStrength.length || !passwordStrength.lowercase ||
            !passwordStrength.uppercase || !passwordStrength.number) {
            setErrors({ confirmPassword: "Password does not meet requirements." });
            return false;
        }

        if (newPassword.length < 6 || newPassword.length > 15) {
            setErrors({ confirmPassword: "Password must be between 6 and 15 characters." });
            return false;
        }

        setErrors({ confirmPassword: "Password Matched" });
        return true;
    };


    const handleSubmitClick = async () => {
        if (!validatePassword()) return;

        setIsLoading(true);

        try {
            const response = await resetPassword(email, userType, newPassword, repeatPassword, token);

            if (response.status) {
                toast.success(response.message || "Password reset successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                });
                setIsLoginModalOpen(true);
            } else {
                if (response.message) {
                    toast.error(response.message, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            }
        } catch (error) {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            } else if (error.message) {
                toast.error(error.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleRepeatPasswordVisibility = () => {
        setRepeatPasswordVisible(!repeatPasswordVisible);
    };

    const handlePasswordChange = (e) => {
        const { value } = e.target;
        // Limit input to 15 characters
        const truncatedValue = value.slice(0, 15);
        setNewPassword(truncatedValue);

        const updatedStrength = {
            length: truncatedValue.length >= 6 && truncatedValue.length <= 15,
            lowercase: /[a-z]/.test(truncatedValue),
            uppercase: /[A-Z]/.test(truncatedValue),
            number: /[0-9]/.test(truncatedValue),
        };
        setPasswordStrength(updatedStrength);
    };

    const handleRepeatPasswordChange = (e) => {
        const { value } = e.target;
        // Limit input to 15 characters
        const truncatedValue = value.slice(0, 15);
        setRepeatPassword(truncatedValue);
    };

    if (!isOpen) return null;

    return (
        <div className="forgetEmailOverlay">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
            />

            {!isLoginModalOpen && isOpen && (
                <div className="forgetEmailModal">
                    <div className="headerforgets-pass">
                        <h2 className="forgetTitle">Create a new password</h2>
                    </div>
                    <div className="inputGroups inputGroups-pass">
                        <label htmlFor="newPassword">New Password</label>
                        <div className="passwordInputWrapper-pass">
                            <input
                                type={passwordVisible ? "text" : "password"}
                                id="newPassword"
                                className="loginInput-pass"
                                value={newPassword}
                                onChange={handlePasswordChange}
                                maxLength={15}
                            />
                            <span className="eyeIcon-pass" onClick={togglePasswordVisibility}>
                                {passwordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                            </span>
                        </div>
                    </div>
                    <div className="inputGroups inputGroups-pass">
                        <label htmlFor="repeatPassword">Repeat New Password</label>
                        <div className="passwordInputWrapper-pass">
                            <input
                                type={repeatPasswordVisible ? "text" : "password"}
                                id="repeatPassword"
                                className="loginInput-pass"
                                value={repeatPassword}
                                onChange={handleRepeatPasswordChange}
                                maxLength={15}
                            />
                            <span className="eyeIcon-pass" onClick={toggleRepeatPasswordVisibility}>
                                {repeatPasswordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                            </span>
                        </div>
                    </div>

                    <p className={errors.confirmPassword === "Password Matched" ? "success-message" : "error-message"}>
                        {errors.confirmPassword}
                    </p>                    <p className="password-info">
                        <span className="password-info-wrapper">
                            <MdOutlineLock className="lock-icon" />
                            Password must:
                        </span>
                        <ul>
                            <li>
                                <TiTick className={`tick-icon ${passwordStrength.length ? "valid" : ""}`} />
                                Be a minimum of 6 to 15 characters
                            </li>
                            <li>
                                <TiTick className={`tick-icon ${passwordStrength.lowercase ? "valid" : ""}`} />
                                Include at least one lowercase letter (a-z)
                            </li>
                            <li>
                                <TiTick className={`tick-icon ${passwordStrength.uppercase ? "valid" : ""}`} />
                                Include at least one uppercase letter (A-Z)
                            </li>
                            <li>
                                <TiTick className={`tick-icon ${passwordStrength.number ? "valid" : ""}`} />
                                Include at least one number (0-9)
                            </li>
                        </ul>
                    </p>

                    <button
                        className="loginBtn"
                        onClick={handleSubmitClick}
                        disabled={isLoading}
                    >
                        {isLoading ? "Submitting..." : "SUBMIT"}
                    </button>
                    <button className="closeModalBtn" onClick={onClose}>
                        <RxCross2 />
                    </button>
                </div>
            )}

            {isLoginModalOpen && (
                <ResetPassword
                    isOpen={isLoginModalOpen}
                    onClose={() => setIsLoginModalOpen(false)}
                />
            )}
        </div>
    );
};

export default NewPassword;